import { render } from "./admin.vue?vue&type=template&id=351ea3dd"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"
script.render = render

export default script